import React from "react";

const Main = ({ children }) => {
  return (
    <div className="flex-1 min-h-screen bg-gray-50">
      <div className="p-6">{children}</div>
    </div>
  );
};

export default Main;
